import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const isVoucherSupported = async _ref => {
  let {
    httpClient,
    request: {
      domain
    }
  } = _ref;
  const parsedDomain = parseDomain(domain);
  const requestedTld = (domain == null ? void 0 : domain.tld) ?? parsedDomain.tld;
  const {
    checkDomainAvailability,
    domainTlds,
    listEligibleCoupons
  } = await dynamicLoadApiQueries(httpClient);
  const [{
    tlds
  }, {
    coupons
  }, {
    availability
  }] = await Promise.all([domainTlds({}), listEligibleCoupons({}), checkDomainAvailability({
    domain: parsedDomain.asciiDomain
  })]);
  const tldData = tlds.find(_ref2 => {
    let {
      tld
    } = _ref2;
    return tld === requestedTld;
  });
  const isPremium = !!(availability != null && availability.premium);
  const isVoucherSupportedTld = (tldData == null ? void 0 : tldData.couponsApplicable) && !isPremium;
  return {
    isVoucherSupported: !!isVoucherSupportedTld,
    hasValidVouchers: !!(coupons != null && coupons.length)
  };
};
//# sourceMappingURL=isVoucherSupported.js.map